import React from 'react';
import { connect } from 'react-redux';

import { updateCampaignAggregates, getFocusedCampaign } from '../../store/api/calls';

import NavBaseTemplate from '../templates/NavBaseTemplate';
import BaseModal from '../theme/modals/BaseModal';
import FeedbackTile from '../theme/modals/FeedbackTile';
import Moment from 'moment';
import api from '../../store/api/api';
import Input from '../theme/forms/Input';
import QRCode from 'qrcode.react';

class MFASetUpForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      step: 1,
      loading: false,
      mfa_configuration_uri: '',
      step_1_error: null,
      returned_mfa_code: null,
      input_mfa_code: null,
      input_mfa_code_error: null,
    };
  }

  componentDidMount() {
    this.requestMFAEnabled();
  }

  requestMFAEnabled = () => {
    this.setState({ loading: true });
    return api
      .get('/request-mfa-enabled/')
      .catch((err) => {
        console.log(err);
        this.setState({ step_1_error: 'There was a problem retrieving your setup code.' });
      })
      .then((res) => {
        this.setState({
          mfa_configuration_uri: res.data.setup_uri,
        });
      })
      .then(() => this.setState({ loading: false }));
  };

  confirmMFACode = () => {
    this.setState({ input_mfa_code_error: null });
    this.setState({ loading: true });
    api
      .post('/confirm-mfa/', { otp: this.state.input_mfa_code })
      .then(() => {
        this.setState({ step: 3 });
        this.props.onSetUpSucess();
      })
      .catch((err) => {
        if (err.response.status === 409) {
          this.setState({ input_mfa_code_error: 'That was not a valid code' });
        } else {
          this.setState({ input_mfa_code_error: 'There was an error processing that request' });
        }
      })
      .then(() => this.setState({ loading: false }));
  };

  render() {
    if (this.state.loading)
      return (
        <div className={'flx align_center center'} style={{ height: '10em' }}>
          <h3 className={'primary-text'} style={{ margin: 0 }}>
            <i className="fas fa-asterisk fa-spin" /> Loading
          </h3>
        </div>
      );

    return (
      <div style={{ margin: '1em' }}>
        <p className={'primary-text'}>{this.props.title || 'Set up MFA'}</p>

        {this.state.step === 1 && (
          <>
            <p>Scan this code in Google Authenticator.</p>
            <div className={'flx align_center flx_column'}>
              <QRCode value={this.state.mfa_configuration_uri} size={256} />
              <div
                className={'button'}
                style={{ marginLeft: '3em', marginTop: '2.3em' }}
                onClick={() => {
                  this.setState({ step: 2 });
                }}
              >
                {' '}
                I'm ready to input the code displayed on my phone
              </div>
            </div>

            {this.state.input_cell_phone_error && (
              <p className={'danger-text'}>That's not a valid ten digit number</p>
            )}
          </>
        )}

        {this.state.step === 2 && (
          <>
            <p>Enter the six digit code displayed in Google Authenticator</p>
            <div className={'flx align_center'}>
              <Input
                type="text"
                title={'Code'}
                value={this.state.input_mfa_code}
                onChange={(val) => {
                  this.setState({ input_mfa_code: val });
                }}
              />
              <div
                className={'button'}
                style={{ marginLeft: '3em', marginTop: '2.3em' }}
                disabled={!this.state.input_mfa_code || this.state.input_mfa_code.length !== 6}
                onClick={() => this.confirmMFACode()}
              >
                Submit
              </div>
              <div
                className={'button secondary-milligram'}
                style={{ marginLeft: '3em', marginTop: '2.3em' }}
                onClick={() => this.setState({ step: 1 })}
              >
                Go Back
              </div>
            </div>
            {this.state.input_mfa_code_error && (
              <p className={'danger-text'}>That's not the right code.</p>
            )}
          </>
        )}
        {this.state.step === 3 && (
          <>
            <p className={'success-text'}>
              Success! A one time password will now be required on login.
            </p>
            <div className={'flx align_center flx_column'}>
              <div className={'button secondary-milligram'} onClick={this.props.dismissModal}>
                {' '}
                Ok
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}

export default MFASetUpForm;
